import { sid, scheduledifference, getSpeechInfoNew, getScheduleInfo, getScheduleInfoFinal, getSue, getSueArr, getSueType, scheduleDifferenceId } from "@/utils/api.js";

export default {
  data () {
    let _this = this;
    return {
      sid: sid(_this.global.year),
      scheduleDifference: {}, // scheduledifference(_this.global.year),
    }
  },
  methods: {
    getPeriod(times) {
      let period = 'am';
      if(times && times.length > 0) {
        let hours = times.slice(0,2);
        if(!hours.includes(':') && !hours.includes('：')) {
          // let minutes = times.slice(3,5);
          if(hours > '12') {
            period = 'pm';
          }
        }
      }
      return period;
    },
    setDifferenceKey(day, groupid, index) {
      let period = ''
      let periodArr = ['am', 'pm']
      if (periodArr.includes(index)) {
        period = index
      } else {
        period = [0,1,'0','1'].includes(index) ? periodArr[parseInt(index)] : ''
      }
      let key = `${this.global.year}_${day}_${groupid}_${period}`
      return key;
    },
    getDifference() {
      let url = getSueType + scheduleDifferenceId;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          // console.log("difference ", res);
          if ([0, '0'].includes(res.errno) && res.data) {
            let baseType = ''
            let type = ''
            let typeList = []
            for(let item of res.data) {
              baseType = ((item.typeName && item.typeName.toString()) || '').trim()
              type = baseType.toLocaleLowerCase();
              if(type && type.includes('giac')) {
                typeList.push({
                  id: item.id,
                  name: type.split('#')[1],
                  clauseActivityId: baseType.split('#')[2] || '',
                  vName: baseType.split('#')[3] || '',
                  producers: baseType.split('#')[4] || '',
                });
              }
            }
            this.getScheduleDifference(typeList);
          }
        })
    },
    getScheduleDifference(typeList) {
      // 初始化数据结构
      let difference = {}
      for (let type of typeList) {
        if (type.name && type.name.includes(this.global.year)) {
          let isTencent = (type.vName && type.vName.includes('腾讯')) || ['2024sz', '2025sz'].includes(this.global.year) || false
          let clauseUrl = isTencent ? 'https://www.msup.com.cn/site/clause-activity' : 'https://www.msup.com.cn/site/clause'
          difference[type.name] = {
            courses: [],
            length: type.name.includes('am') ? 3 : (type.name.includes('pm') ? 4 : 0),
            linkUrl: type.clauseActivityId ? `${clauseUrl}?id=${type.clauseActivityId}` : '',
            vName: (type.vName && type.vName.split('||')[0]) || '',
            vTime: (type.vName && type.vName.split('||')[1]) || '',
            vSource: (type.vName && type.vName.split('||')[2]) || '',
            producers: (type.producers || '').split(','),
            producersId: (type.producers || '').split(',').map(item => {
              return (item && item.split('-') && item.split('-')[1]) || ''
            }).join(','),
            producersName: (type.producers || '').split(',').map(item => {
              return (item && item.split('-') && item.split('-')[0]) || ''
            }).join(' ')
          }
          this.$forceUpdate()
        }
      }
      // console.log("difference ", typeList, difference);
      // 获取数据
      let url = getSueArr + scheduleDifferenceId;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          // console.log("difference ", res);
          if ([0, '0'].includes(res.errno) && res.data) {
            for(let typeItem of typeList) {
              if(difference[typeItem.name]) {
                difference[typeItem.name].courses = []
                let course = {}, lecturers=[], lecturer='', times=[], titles=[], title='', courseDesc=''
                for(let index in res.data[0]) {
                  let course = res.data[0][index]
                  // console.log(course, typeItem, difference)
                  // schedule-difference
                  if (course.detailType == typeItem.id) {
                    lecturers = course.content && course.content.length>0 && course.content.split(' /// ')
                    if(course.content_note && course.content_note.length>0) {
                      times = (course.content_note.split('scheduleTitle--')[0] || '').replace('time--','').replace(/\r\n/g,'').split('-');
                      // titles = (course.content_note.split('desc--')[0].split('scheduleTitle--')[1] || '').replace(/^\r\n/,'').split('\r\n');
                      courseDesc = (course.content_note.split('desc--')[1] || '').replace('desc--','').replace(/\r\n/g,'')
                    }
                    difference[typeItem.name].courses.push({
                      // courseTitle: course.title,
                      // lecturers: [],
                      // times: times,
                      courseId: (course.title && course.title.split('||') && course.title.split('||')[1]) || '',
                      courseTitle: (course.title && course.title.split('||') && course.title.split('||')[0]) || '敬请期待',
                      lecturers: [],
                      times: times,
                      courseDesc
                    });
                    let cIndex = difference[typeItem.name].courses.length - 1
                    for(let lindex in lecturers) {
                      lecturer = lecturers[lindex] || '';
                      // title = titles[lindex] || '';
                      if(lecturer.split(' || ')[0] && lecturer.split(' || ')[0].trim() !== '客户技术高层') {
                        difference[typeItem.name].courses[cIndex].lecturers.push({
                          name: lecturer.split(' || ')[0] || '',
                          company: lecturer.split(' || ')[1] || '',
                          position: lecturer.split(' || ')[2] || '',
                          // courseTitle: title, // 不需要显示讲师议题
                        });
                      }
                    }
                  }
                }
                difference[typeItem.name].length = difference[typeItem.name].courses.length || difference[typeItem.name].length || 0
                difference[typeItem.name].timeStamp = new Date().getTime()
              }
            }
          }
          // console.log("difference ", difference);
          this.scheduleDifference = difference
          this.$forceUpdate()
        })
    },
  }
}